import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=e39aed7e&scoped=true&"
import script from "./MenuSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuSidebar.vue?vue&type=style&index=0&id=e39aed7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39aed7e",
  null
  
)

export default component.exports